// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // serverIP:'http://192.168.100.32:8012/'
  //  serverIP:'https://api-casemanager.lfdanalytics.com/',
   serverIP:'https://faml-casemgr-devapi.lfdanalytics.com/',
  //  serverIP:'http://192.168.14.35:8000/',
  imagelinkPath:'https://v2-api.entityscan.com/media/img/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
